<template>
	<v-overlay
		:z-index="55"
		v-show="vModel"
		:opacity="0.6"
		:class="['animate__animated', 'animate__faster', ui.animations.overlay]"
	>
		<div class="inshadow" @click="close()"></div>

		<div
			:class="[
				'overlay-content',
				'elevation-5',
				'animate__animated',
				ui.animations.content,
			]"
		>
			<v-container class="pt-0 pb-0">
				<v-row>
					<v-col
						cols="12"
						class="d-flex align-center justify-space-between overlay-top"
					>
						<div class="d-flex flex-column justify-center">
							<h2>
								<!-- Slot title -->
								<slot name="title"></slot>
							</h2>
							<small>
								<!-- Slot subtitle -->
								<slot name="subtitle"></slot>
							</small>
						</div>

						<v-btn
							fab
							color="#eee"
							@click="close()"
							:class="[
								'elevation-0',
								'black--text',
								'ma-0',
								'animate__animated',
								'animate__rotateIn',
							]"
						>
							<v-icon>
								mdi-close
							</v-icon>
						</v-btn>
					</v-col>

					<v-col cols="12" class="pa-0 overlay-body">
						<!-- Slot content -->
						<slot name="content"></slot>
					</v-col>
				</v-row>
			</v-container>
		</div>
	</v-overlay>
</template>

<script>
import { EventBus } from "@/main";

export default {
	props: {
		value: [Boolean],
	},

	data() {
		return {
			ui: {
				show: false,
				animations: {
					overlay: "animate__fadeIn",
					content: "animate__slideInRight",
				},
			},
		};
	},

	methods: {
		close() {
			this.ui.animations = {
				overlay: "animate__fadeOut",
				content: "animate__slideOutRight",
			};

			setTimeout(() => {
				this.vModel = false;

				this.ui.animations = {
					overlay: "animate__fadeIn",
					content: "animate__slideInRight",
				};
			}, 300);
		},
	},

	computed: {
		vModel: {
			get() {
				return this.value;
			},

			set(newValue) {
				this.$emit("input", newValue);
			},
		},
	},
};
</script>

<style lang="css" scoped>
.overlay-content {
	right: 0;
	top: 0;
	z-index: 2;
	width: 35vw;
	height: 100vh;
	/*overflow-y: scroll;*/
	overflow: hidden;
	position: fixed;
	background-color: #fff;
	animation-duration: 0.3s;
}

.overlay-content,
.overlay-content > * {
	color: initial;
}
.inshadow {
	left: 0;
	top: 0;
	height: 100vh;
	width: 100vw;
}

.overlay-top {
	position: fixed;
	width: 100%;
	top: 0;
	height: 85px;
}

.overlay-body {
	position: relative;
	margin-top: 80px;
	height: calc(100vh - 90px);
	overflow-y: scroll;
}

/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 960px) {
	.overlay-content {
		width: 75vw;
	}
}
</style>
